import axios from "axios";
import { API_KEY, API_URL } from "../constants/api";

export default async function loadForecast(
  coordinates = {},
  handleResponse,
  unit
) {
  const { lat, lon } = coordinates;
  const url = `${API_URL}onecall?lat=${lat}&lon=${lon}&appid=${API_KEY}&units=${unit}`;

  try {
    const response = await axios.get(url);

    handleResponse(response.data);
  } catch (error) {
    console.error(error);
  }
}
